export const defaultIcon: any = {
  position: 'absolute',
  display: 'block',
  top: '50%',
  left: '50%',
  width: '1em',
  maxWidth: '1em',
  background: 'currentColor',
  transform: 'translate(-50%, -50%)',
  borderRadius: '.1em',
  transition: '500ms cubic-bezier(.4, 0, .2, 1)',
  msTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
  MozTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
  WebkitTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
  '&:before, &:after': {
    content: '""',
    position: 'absolute',
    display: 'block',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    height: '100%',
    background: 'inherit',
    transform: 'translate(-50%, -50%)',
    transition: '500ms cubic-bezier(.4, 0, .2, 1)',
    msTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
    MozTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
    WebkitTransition: '500ms cubic-bezier(.4, 0, .2, 1)',
    borderRadius: '.1em',
  },
};
